/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type messaging_ReadReceiptResponse = {
    /**
     * DisplayName is the reader's name; absent for daycare and when the reader cannot be resolved.
     */
    display_name?: string;
    /**
     * ReadAt is the reader's LAST open of the thread, not the first read of a given message.
     */
    read_at: string;
    /**
     * ReaderType is employee or parent for a staff caller. A parent caller gets at most one
     * daycare entry, the latest read of any staff member, with no user_id or display_name.
     */
    reader_type: messaging_ReadReceiptResponse.reader_type;
    /**
     * UserID is the Clerk user id of an employee reader or the contact id of a parent reader; absent for daycare.
     */
    user_id?: string;
};
export namespace messaging_ReadReceiptResponse {
    /**
     * ReaderType is employee or parent for a staff caller. A parent caller gets at most one
     * daycare entry, the latest read of any staff member, with no user_id or display_name.
     */
    export enum reader_type {
        EMPLOYEE = 'employee',
        PARENT = 'parent',
        DAYCARE = 'daycare',
    }
}

